/**
 * Zod schemas on these screens carry a key rather than a sentence, so the rule and
 * its wording stay in different places: the schema says `passwordTooShort`, the
 * locale file decides how that reads, in whichever language the person chose.
 */
export const messageFor = (
  key: string | undefined,
  t: (key: string) => string,
): string | undefined => (key ? t(`validation.${key}`) : undefined);
